import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	aiDisclaimerPopupContent: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.disclaimer-tooltip.ai-disclaimer-popup-content',
		defaultMessage: 'The quality of AI-generated information may vary. <a>Learn why</a>',
		description:
			"Disclaimer shown for AI generated content with a link to learn more about Atlassian's trust policy.",
	},
	infoIconLabel: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.disclaimer-tooltip.info-icon-label',
		defaultMessage: 'Atlassian Intelligence trust information.',
		description:
			"Label read by screen readers when focusing on the information icon to learn more about Atlassian's trust policy.",
	},
	infoIconTooltip: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.search-mode-switcher.disclaimer-tooltip.info-icon-tooltip',
		defaultMessage: 'About AI',
		description:
			"Tooltip shown when focusing focusing on the information icon to learn more about Atlassian's trust policy.",
	},
});
